<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" scrollable>
			<v-card>
				<v-card-title class="text-h6">Form Bank</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Nama" v-model="params.name" @focus="() => error_validation.name = ''" :error-messages="error_validation.name"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-autocomplete outlined dense v-model="params.is_active" :items="list_status" label="Status" class="width-0" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
const list_status = [{
	value: '1',
	text: 'Aktif'
}, {
	value: '0',
	text: 'Tidak Aktif'
}];

export default {
	data () {
		return {
			params: {
				id: '',
				name: '',
				is_active: '',
			},
			list_status: list_status,
			status: '',
			dialog: false,
		}
	},
	props: {
	},
	computed: {
		...mapState(['error_validation']),
	},
	methods: {
		...mapMutations(['validationError']),

		showModal() {
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
		},
		defineParams(data) {
			this.validationError({})
			this.params.id = data.bank_id
			this.params.name = data.bank_name
			this.params.is_active = data.bank_is_active
		},
		simpan(){
			this.$emit('save', this.params)
		}
	},
	watch: {
	},
	created() {
	}
}
</script>
